// TabsNavigation.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import flightIcon from "../../assets/svg2/flyWHITE.svg";
import bedIcon from "../../assets/svg2/bedWHITE.svg";

export const TabsNavigation = () => {
  const navigate = useNavigate();
  return (
    <ul className="nav nav-tabs" style={{ paddingLeft: "16px" }}>
      <li>
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            navigate("/");
          }}
          style={{ textDecoration: "none" }}
        >
          <img src={flightIcon} alt="Flight"  style={{ width: '50px', height: '50px' }} /> Flights
        </a>
      </li>
      <li>
        <a
          href="/hotels"
          className="active"
          onClick={(e) => {
            e.preventDefault();
            navigate("/hotels");
          }}
        >
          <img src={bedIcon} alt="Hotel" style={{ width: '50px', height: '50px' }} /> Hotels
        </a>
      </li>
    </ul>
  );
};
